import api from './api';

/**
 * @param {string} levelId
 * @param {string} skillId
 * @param {string} testId
 * @param {string[]} tasks
 * @param {string} testName
 * @param {string} qpvReferenceName
 * @returns {Promise<{
 *  test_id: string
 *  test_name: string
 *  skill_id: string
 *  qpv_reference: string
 *  tasks: {
 *      order: number
 *      task_id: string
 *      task_type_id: string
 *      description: string
 *  }[]
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Tests-putTests
 */
export default async function updateTestComponent(levelId, skillId, testId, tasks, testName, qpvReferenceName) {
    const { data } = await api.put(
        `/levels/${levelId}/skills/${skillId}/tests/${testId}`, {
            tasks,
            test_name: testName,
            qpv_reference: qpvReferenceName
        }
    );

    return data;
}